import { createContext, useContext, useState, useEffect } from 'react';
import { useGetConversations } from '../hooks/useGetConversations';
import { useContext as useReactContext } from 'react';
import { AuthContext } from './AuthContext';

const INITIAL_STATE = {
  conversationsData: [],
  conversationsStatus: 'idle',
  refetchConversations: () => {},
  conversations: [],
  setConversations: () => {},
  totalUnReadMessages: 0,
  setTotalUnReadMessages: () => {},
};

const ConversationsContext = createContext(INITIAL_STATE);

export function useConversations() {
  return useContext(ConversationsContext);
}

export const ConversationsProvider = ({ children }) => {
  const { player } = useReactContext(AuthContext);
  const [conversations, setConversations] = useState([]);
  const [totalUnReadMessages, setTotalUnReadMessages] = useState(0);

  const onSuccess = () => {};
  const onError = () => {};

  const {
    data: conversationsData = [],
    status: conversationsStatus = 'idle',
    refetch: refetchConversations,
    isSuccess,
  } = useGetConversations(onSuccess, onError, player);

  useEffect(() => {
    if (!player) {
      setConversations([]);
      setTotalUnReadMessages(0);
      return;
    }
  }, [player]);

  useEffect(() => {
    if (player && isSuccess && conversationsData) {
      setConversations((prev) => {
        if (prev === conversationsData) return prev;
        return conversationsData;
      });
    }
  }, [player, isSuccess, conversationsData]);

  return (
    <ConversationsContext.Provider
      value={{
        conversationsData,
        conversationsStatus,
        refetchConversations,
        conversations,
        setConversations,
        totalUnReadMessages,
        setTotalUnReadMessages,
      }}
    >
      {children}
    </ConversationsContext.Provider>
  );
};
